import React from 'react';
import StickyBox from 'react-sticky-box';
import type { WordpressPost, WordpressSidebar } from '@benzinga/content-manager';
// import { MoneySidebar } from '@benzinga/money';

const MoneySidebar = React.lazy(() =>
  import('@benzinga/money').then(module => {
    return { default: module.MoneySidebar };
  }),
);

const FreestarAd = React.lazy(() => import('@benzinga/ads').then(module => ({ default: module.FreestarAd })));

// const GoogleAdUnit = React.lazy(() =>
//   import('@benzinga/ads').then(module => {
//     return { default: module.GoogleAdUnit };
//   }),
// );

const WatchlistSidebarWidget = React.lazy(() =>
  import('@benzinga/widgets').then(module => {
    return { default: module.WatchlistSidebarWidget };
  }),
);

export interface DefaultSidebarProps {
  post?: WordpressPost | null;
  sidebar?: WordpressSidebar | null;
  showWatchlistWidget?: boolean;
  enableDisplayAd?: boolean;
}

const DefaultSidebar: React.FC<React.PropsWithChildren<DefaultSidebarProps>> = ({
  children,
  enableDisplayAd = true,
  post,
  showWatchlistWidget = true,
  sidebar,
}) => {
  return (
    <StickyBox className="default-sidebar-container" offsetBottom={20} offsetTop={20}>
      <div>
        {showWatchlistWidget && (
          <div className="mb-4">
            <WatchlistSidebarWidget />
          </div>
        )}

        {children}

        {sidebar && <MoneySidebar post={post} sidebar={sidebar} />}

        {enableDisplayAd && !sidebar && !children && (
          // <div style={{ height: '600px', margin: 'auto', marginTop: '16px', textAlign: 'center', width: '300px' }}>
          //   <GoogleAdUnit adUnit="DotCom_600x300" dfpNetworkId="4107070" sizes={[[300, 600]]} />
          // </div>

          <FreestarAd className="w-[300px] mb-2 overflow-hidden" placement="sidebar_1" />
        )}
      </div>
    </StickyBox>
  );
};

export default DefaultSidebar;
